import type { WireParams, Wiring } from '@empathyco/x-components'
import { filter, namespacedWireCommit, namespacedWireDispatch } from '@empathyco/x-components'
import { setSearchQuery } from '@empathyco/x-components/search'

const moduleName = 'search'
const wireCommit = namespacedWireCommit(moduleName)
const wireDispatch = namespacedWireDispatch(moduleName)

const isFacetsAsideModal = ({ eventPayload }: { eventPayload: string }): boolean =>
  eventPayload === 'aside-modal' || eventPayload === 'right-aside'

const isNewRequest = (params: WireParams<unknown>): boolean => {
  const oldRequest = params.store.state.x.search.oldRequest
  // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-member-access
  const newRequest = params.store.getters['x/search/request']

  return JSON.stringify(oldRequest) !== JSON.stringify(newRequest)
}

const shouldReloadResults = (params: WireParams<string>): boolean => {
  return isFacetsAsideModal(params) && isNewRequest(params)
}

const setOldRequestWire = wireCommit('setOldRequest')
const setIsFacetsAsideOpenWire = wireCommit('setIsFacetsAsideOpen', true)

const setOldRequestFilteredWire = filter(wireCommit('setOldRequest', null), isFacetsAsideModal)

const setIsFacetsAsideOpenFilteredWire = filter(
  wireCommit('setIsFacetsAsideOpen', false),
  isFacetsAsideModal,
)

const reloadSearchResponseFilteredWire = filter(
  wireDispatch('fetchAndSaveSearchResponse', ({ getters }) => getters.request),
  shouldReloadResults,
)

const setSearchQueryFiltered = filter(
  setSearchQuery,
  ({ eventPayload }) => !eventPayload.startsWith('::'),
)

export const searchWiring: Partial<Wiring> = {
  UserAcceptedAQuery: {
    setSearchQuery: setSearchQueryFiltered,
  },
  UserOpenedFacetsAside: {
    setOldRequestWire,
    setIsFacetsAsideOpenWire,
  },
  UserClickedOutOfModal: {
    reloadSearchResponseFilteredWire,
    setOldRequestFilteredWire,
    setIsFacetsAsideOpenFilteredWire,
  },
  UserClickedCloseModal: {
    reloadSearchResponseFilteredWire,
    setOldRequestFilteredWire,
    setIsFacetsAsideOpenFilteredWire,
  },
}
